const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const ItemInstanceOrderMap = require('@/lib/Orders/ItemInstanceOrderMap');

/**
 * This repository is different from most others because we don't pull down all the orders during a sync,
 * and we don't clear it during a sync.
 * This is populated when you click the "Download Orders" button from the Settings menu.
 * It stores a list of item instance refs for orders that contain tickets for the current day
 * (at the time Download was pressed) or orders that contain open tickets.
 */
class ItemInstanceOrderMapRepository extends AbstractRepository {
    /**
     * This useless-looking constructor must exist so that the AngularJS injector can do its thing.
     *
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(
        dataStore,
        hydrator,
        syncStateManager
    ) {
        super(
            dataStore,
            hydrator,
            syncStateManager
        );
    }

    /**
     * @protected
     */
    getEntityName() {
        return 'ItemInstanceOrderMap';
    }

    /**
     * @protected
     */
    getEntityClass() {
        return ItemInstanceOrderMap;
    }

    /**
     * @protected
     */
    getTableName() {
        return DataStoreNames.ITEM_INSTANCE_ORDER_MAP;
    }

    find() {
        throw new Error('find() is not supported for this repository. Use findByItemInstanceRef() instead.');
    }

    sync() {
        // We don't want to use the regular syncing logic here.
        throw new Error('Use OrderDownloader to download orders and their instances.');
    }

    loadFromApi() {
        // We don't want to use the regular syncing logic here.
        throw new Error('Use OrderDownloader to download orders and their instances.');
    }

    /**
     * @param {string} itemInstanceRef
     *
     * @return {Promise<ItemInstanceOrderMap>}
     */
    findByItemInstanceRef(itemInstanceRef) {
        itemInstanceRef = itemInstanceRef.toUpperCase();

        return this.dataStore.findWhere(this.getTableName(), 'itemInstanceRef', itemInstanceRef)
            .then((data) => {
                // findWhere returns an array, but we know that a itemInstanceRef is like a primary key so there will
                // only be 1 or 0 results.
                if (!data || data.length < 1) {
                    // Throwing an error rejects the promise.
                    throw new Error(`An ItemInstanceOrderMap with itemInstanceRef ${itemInstanceRef} was not found.`);
                }

                return this.hydrator.hydrate(data[0], new ItemInstanceOrderMap());
            });
    }
}

module.exports = ItemInstanceOrderMapRepository;
